import { useHistory } from 'react-router-dom'

const useDropdownMenuItems = items => {
  const history = useHistory()
  const hashPath = window?.location?.hash
  const currentPath = history?.location?.pathname + hashPath

  const isCurrentPath = item => {
    const isArrayPath = Array.isArray(item?.path)
    return isArrayPath
      ? item.path.some(path => currentPath?.startsWith(path))
      : currentPath?.startsWith(item?.path)
  }

  return {
    isCurrentPath
  }
}

export default useDropdownMenuItems
